<template>
  <div class="tanchuang-frame">
    <div class="tanchuang-frame__body">
      <slot :background-style="backgroundStyle" :background-src="backgroundImage"></slot>
    </div>
    <div v-if="title" class="tanchuang-frame__title" :data-title="title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'TanchuangFrame',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      backgroundImage: require('@/assets/tanchuang.png')
    }
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%'
      }
    }
  }
}
</script>

<style scoped>
.tanchuang-frame {
  position: relative;
  display: inline-flex;
  flex: 0 0 auto;
  width: min(75vw, 1440px, 129vh);
  aspect-ratio: 1197 / 842;
  max-width: calc(100vw - 24px);
  max-height: calc(100vh - 24px);
}

.tanchuang-frame__body {
  position: absolute;
  inset: 0;
  display: flex;
  min-width: 0;
  min-height: 0;
}

.tanchuang-frame__title {
  position: absolute;
  top: clamp(34px, 2.6vw, 50px);
  left: 50%;
  z-index: 6;
  font-family: "Microsoft YaHei UI", "Microsoft YaHei", "PingFang SC", Arial, sans-serif;
  font-size: clamp(26px, 2.1vw, 40px);
  font-style: italic;
  font-weight: 900;
  line-height: 1.2;
  letter-spacing: 4px;
  text-align: center;
  transform: translateX(-50%) skewX(-8deg);
  pointer-events: none;
  white-space: nowrap;
  color: transparent;
}

.tanchuang-frame__title::before,
.tanchuang-frame__title::after {
  content: attr(data-title);
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.tanchuang-frame__title::before {
  z-index: -1;
  -webkit-text-fill-color: #053b5c;
  -webkit-text-stroke: 1.5px #0a4d7a;
  text-shadow:
    1px 1px 0 #0a4d7a,
    2px 2px 0 #083c5e,
    3px 3px 0 #062b42,
    4px 4px 0 #041a26,
    5px 5px 0 #02090a,
    6px 6px 4px rgba(0, 0, 0, 0.6),
    0 0 12px rgba(100, 200, 255, 0.5);
}

.tanchuang-frame__title::after {
  z-index: 1;
  background: linear-gradient(180deg, #FFFFFF 20%, #74c7ff 80%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
